import { Provider } from "react-redux";
import Store from "../Redux/Store/Store";
import { AppProvider } from "../Pages/Modules/ResizeTable/ResizeTable";

const ContextProviders = ({ children }) => {
  return (
    <Provider store={Store}>
      <AppProvider>{children}</AppProvider>
    </Provider>
  );
};

export default ContextProviders;
